module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.0b28710a.ttf";